import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../reducers';
import { getPracticesByGameId, loadPractices } from '../actions';
import { useCallback } from 'react';

export const usePracticesState = () => {
  return useSelector((state: RootState) => state.practices);
};

export const usePracticesDispatch = () => {
  const dispatch = useDispatch();
  return {
    loadPractices: useCallback((loader: boolean) => () => dispatch(loadPractices(loader)), [dispatch]),
    getPracticesByGameId: (teamId: string, loader: boolean) => () => dispatch(getPracticesByGameId(teamId, loader))
  };
};